import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@store/baseQueries";
import {
  deleteAdvanceSearch,
  fetchAdvanceSearchFields,
  fetchAdvanceSearchResults,
  fetchPrimaryDropdowns,
  fetchSavedAdvanceSearchFilters,
  getCorrectImportersExporters,
  saveAdvanceSearch,
  updateAdvanceSearchFields,
} from "./queries";
import { advanceSearchBaseUrl } from "@store/urlPaths";
import { message } from "antd";
import { getErrorMessage } from "@utils/error";

const advanceSearchApi = createApi({
  reducerPath: "advanceSearch",
  baseQuery: baseQuery(advanceSearchBaseUrl),
  tagTypes: ["SAVE-ADVANCE-SEARCH"],
  endpoints: (builder) => ({
    // fetch advance search fields
    fetchAdvanceSearchFields: builder.query({
      query: fetchAdvanceSearchFields,
    }),

    // update advance search fields
    updateAdvanceSearchFields: builder.mutation({
      query: updateAdvanceSearchFields,
    }),

    // fetch advance search primary dropdowns
    fetchPrimaryDropdowns: builder.query({
      query: fetchPrimaryDropdowns,
    }),

    // fetch advance search
    fetchAdvanceSearchResults: builder.query({
      query: fetchAdvanceSearchResults,
    }),

    // save advance search
    saveAdvanceSearch: builder.mutation({
      query: saveAdvanceSearch,
      invalidatesTags: ["SAVE-ADVANCE-SEARCH"],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            message.success(data.msg);
          }
        } catch (error) {
          message.error(getErrorMessage(error));
        }
      },
    }),

    // fetch saved advance search
    fetchSavedAdvanceSearchFilters: builder.query({
      query: fetchSavedAdvanceSearchFilters,
      providesTags: ["SAVE-ADVANCE-SEARCH"],
    }),

    // delete saved advance search
    deleteSavedAdvanceSearch: builder.mutation({
      query: deleteAdvanceSearch,
      invalidatesTags: ["SAVE-ADVANCE-SEARCH"],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            message.success(data.msg);
          }
        } catch (error) {
          message.error(getErrorMessage(error));
        }
      },
    }),

    // fetch possible correct importers and exporters
    fetchPossibleCorrectImportersExporters: builder.query({
      query: getCorrectImportersExporters,
    }),
  }),
});

export const {
  useFetchAdvanceSearchFieldsQuery,
  useFetchPrimaryDropdownsQuery,
  useLazyFetchAdvanceSearchResultsQuery,
  useUpdateAdvanceSearchFieldsMutation,
  useSaveAdvanceSearchMutation,
  useFetchSavedAdvanceSearchFiltersQuery,
  useDeleteSavedAdvanceSearchMutation,
  useFetchPossibleCorrectImportersExportersQuery,
  reducer: advanceSearchReducer,
  reducerPath: advanceSearchReducerPath,
  middleware: advanceSearchMiddleware,
} = advanceSearchApi;
